import { render, staticRenderFns } from "./PendecieNotification.vue?vue&type=template&id=06d72a0a&scoped=true"
import script from "./PendecieNotification.vue?vue&type=script&lang=js"
export * from "./PendecieNotification.vue?vue&type=script&lang=js"
import style0 from "./PendecieNotification.vue?vue&type=style&index=0&id=06d72a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d72a0a",
  null
  
)

export default component.exports